export function getNewest() {
  window.location.reload(true);
}



// WEBPACK FOOTER //
// ./src/components/utilGetNewest.js